module.exports = __webpack_public_path__ + "img/40_38_069_920.4c4dfb0a.jpg";